<template>
  <div class="miny-100vh o-hidden authentigate-login">
    <div class="login-container">
      <div class="flex-logo">
        <img
          src="../assets/logo-for-dark-bg.svg"
          alt="AuthentiGate"
        >
        <h1>Password Reset</h1>
      </div>
      <div class="login">
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter.native="signIn"
        >
          <v-card elevation="0">
            <v-card-title>Reset your password</v-card-title>
            <v-card-subtitle>Get instructions sent to this email that explain how to reset your password</v-card-subtitle>
            <v-card-text>
              <v-text-field
                ref="email"
                v-model="email"
                :disabled="sending"
                :rules="[validateRequired, ...emailRules]"
                label="Email"
                type="email"
                autofocus
                required
                @blur="emailDirty = true"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn
                :to="toLogin"
                large
                text
              >
                Cancel
              </v-btn>
              <v-spacer />
              <v-spacer />
              <v-btn
                :disabled="!canSubmit"
                :loading="sending"
                color="primary"
                large
                @click.stop="sendPasswordReset"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

        <div class="sign-up">
          <v-btn
            x-large
            block
            outlined
            to="/signup"
            color="primary"
          >
            Sign Up
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from '../firebase'
import { validateRequired } from '@/utils/validationRules'

export default {
  name: 'PasswordReset',
  data: function () {
    return {
      valid: false,
      email: null,
      emailDirty: false,
      emailValid: false,
      sending: false
    }
  },
  computed: {
    emailRules() {
      var rules = []
      if (this.emailDirty && !this.emailValid) {
        rules.push("That's not a valid email address.")
      } else {
        rules.push(true)
      }
      return rules
    },
    canSubmit() {
      return this.valid && this.emailValid && !this.sending
    },
    toLogin() {
      return { path: '/login', query: { email: this.email } }
    }
  },
  watch: {
    email: function () {
      this.emailValid = this.$refs.email.$refs.input.validity.valid
    }
  },
  beforeMount() {
    const email = this.$route.query.email
    if (email) {
      this.email = email
    }
  },
  methods: {
    validateRequired,
    async sendPasswordReset() {
      if (!this.canSubmit) {
        return
      }
      const email = this.email
      this.$handlingError(`Error sending password reset email to  "${email}"`, async () => {
        await auth.sendPasswordResetEmail(this.email)
        this.$showSuccessbar(`Password reset email sent to ${email}`)
        this.$router.push(this.toLogin).catch()
      }, { final: () => { this.sending = false } })
    }
  }
}
</script>

<style lang="scss">
.authentigate-login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url('../assets/login-bg-graphic.svg');
  background-color: var(--v-darkslategray-base);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;

  h1 {
    color: white;
    font-weight: 600;
    margin: 20px 0;
  }

  .sign-up .v-btn {
    margin-top: 15px;
    border-color: transparent;
    border-radius: 0;
    border-top: 1px solid rgb(188 188 188 / 30%);
  }
}

.flex-logo {
  flex: 0 1 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login {
  background-color: white;
  min-width: 500px;
}

.flex-logo img {
  max-height: 75px;
}
</style>
